export const actionTypes = {
  SAVE_DRAFT: 'TAPS.3NDFL.XML.SAVE_DRAFT',
  SAVE_DRAFT_SUCCESS: 'TAPS.3NDFL.XML.SAVE_DRAFT_SUCCESS',
  SAVE_DRAFT_FAILURE: 'TAPS.3NDFL.XML.SAVE_DRAFT_FAILURE',
  GET_YEARS: 'TAPS.3NDFL.XML.GET_YEARS',
  GET_YEARS_SUCCESS: 'TAPS.3NDFL.XML.GET_YEARS_SUCCESS',
  GET_YEARS_FAILURE: 'TAPS.3NDFL.XML.GET_YEARS_FAILURE',
  VALIDATE_XML: 'TAPS.3NDFL.XML.VALIDATE_XML',
  VALIDATE_SUCCESS: 'TAPS.3NDFL.XML.VALIDATE_XML_SUCCESS',
  VALIDATE_FAILURE: 'TAPS.3NDFL.XML.VALIDATE_XML_FAILURE',
  SUBMIT_DECLARATION: 'TAPS.3NDFL.XML.SUBMIT_DECLARATION',
  SUBMIT_DECLARATION_SUCCESS: 'TAPS.3NDFL.XML.SUBMIT_DECLARATION_SUCCESS',
  SUBMIT_DECLARATION_FAILURE: 'TAPS.3NDFL.XML.SUBMIT_DECLARATION_FAILURE',
  GET_DRAFT: 'TAPS.3NDFL.XML.GET_DRAFT',
  GET_DRAFT_SUCCESS: 'TAPS.3NDFL.XML.GET_DRAFT_SUCCESS',
  GET_DRAFT_FAILURE: 'TAPS.3NDFL.XML.GET_DRAFT_FAILURE',
  RESET_DRAFT: 'TAPS.3NDFL.XML.RESET_DRAFT',
};

const save3NDFLXMLDraft = (data) => {
  return {
    type: actionTypes.SAVE_DRAFT,
    payload: data,
  };
};

const saveDraftSuccess = (data) => {
  return {
    type: actionTypes.SAVE_DRAFT_SUCCESS,
    payload: data,
  };
};

const saveDraftFailure = (error) => {
  return {
    type: actionTypes.SAVE_DRAFT_FAILURE,
    payload: error,
  };
};

const getYears = () => {
  return {
    type: actionTypes.GET_YEARS,
  };
};

const getYearsSuccess = (data) => {
  return {
    type: actionTypes.GET_YEARS_SUCCESS,
    payload: data,
  };
};

const getYearsFailure = (error) => {
  return {
    type: actionTypes.GET_YEARS_FAILURE,
    payload: error,
  };
};

const validateXML = (data) => {
  return {
    type: actionTypes.VALIDATE_XML,
    payload: data,
  };
};

const validateXMLSuccess = (data) => {
  return {
    type: actionTypes.VALIDATE_SUCCESS,
    payload: data,
  };
};

const validateXMLFailure = (error) => {
  return {
    type: actionTypes.VALIDATE_FAILURE,
    payload: error,
  };
};

const submitDeclaration = (data) => {
  return {
    type: actionTypes.SUBMIT_DECLARATION,
    payload: data,
  };
};

const submitDeclarationSuccess = (data) => {
  return {
    type: actionTypes.SUBMIT_DECLARATION_SUCCESS,
    payload: data,
  };
};

const submitDeclarationFailure = (error) => {
  return {
    type: actionTypes.SUBMIT_DECLARATION_FAILURE,
    payload: error,
  };
};

const getDeclaraionDraft = (declarationId) => {
  return {
    type: actionTypes.GET_DRAFT,
    payload: declarationId,
  };
};

const getDeclaraionDraftSuccess = (draft) => {
  return {
    type: actionTypes.GET_DRAFT_SUCCESS,
    payload: draft,
  };
};

const getDeclaraionDraftFailure = (error) => {
  return {
    type: actionTypes.GET_DRAFT_FAILURE,
    payload: error,
  };
};

const resetDeclarationDraft = () => {
  return {
    type: actionTypes.RESET_DRAFT,
  };
};

export {
  save3NDFLXMLDraft,
  saveDraftSuccess,
  saveDraftFailure,
  getYears,
  getYearsSuccess,
  getYearsFailure,
  validateXML,
  validateXMLSuccess,
  validateXMLFailure,
  submitDeclaration,
  submitDeclarationSuccess,
  submitDeclarationFailure,
  getDeclaraionDraft,
  getDeclaraionDraftSuccess,
  getDeclaraionDraftFailure,
  resetDeclarationDraft,
};
